var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJigayoku(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 27,
    viewBox: "0 0 39 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9419 4.62549C35.7897 4.62549 34.8497 5.54915 34.8497 6.69807C34.8497 7.17867 35.0165 7.61421 35.2894 7.96715L27.5045 13.1335L20.3792 4.1449C21.1069 3.822 21.6072 3.10111 21.6072 2.26007C21.6072 1.11865 20.6748 0.1875 19.515 0.1875C18.3553 0.1875 17.4229 1.11114 17.4229 2.26007C17.4229 3.10111 17.9308 3.822 18.6509 4.1449L11.5255 13.1335L3.7407 7.96715C4.01359 7.61421 4.18035 7.17867 4.18035 6.69807C4.18035 5.55665 3.24799 4.62549 2.08822 4.62549C0.928455 4.62549 -0.00390625 5.54915 -0.00390625 6.69807C-0.00390625 7.84699 0.928455 8.77064 2.08822 8.77064C2.33837 8.77064 2.57335 8.72558 2.79318 8.65048L10.0171 26.8305H28.9827L36.2066 8.65048C36.4264 8.72558 36.6614 8.77064 36.9115 8.77064C38.0637 8.77064 39.0037 7.84699 39.0037 6.69807C39.0037 5.54915 38.0713 4.62549 36.9115 4.62549H36.9419Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJigayoku);
export default __webpack_public_path__ + "static/media/jigayoku.f404acfa3092e47d5975d20f9c2a9a16.svg";
export { ForwardRef as ReactComponent };